module.exports = {
  // jwtSecret: "ccb5597c-3995-42fb-8255-a9557d759293",
  jwtSecret: "53326779-daf7-4a32-9d61-eb0444535b40",
  partneJwtSecret: "533f779-daf7-4a32-9d61-ebKL.44453Ab40",
};
